import { FC } from 'react';

import { GiftOrderDeliveryMode } from '@shared/api/giftOrder/giftOrder.interface';

export const OrderTypeBadge: FC<{ orderType: 'coupon' | 'delivery' | 'mixed' }> = ({
  orderType,
}) => {
  switch (orderType) {
    case 'coupon':
      return (
        <span className="inline-flex rounded-full bg-purple-100 px-2 py-0.5 text-xs font-medium text-purple-700">
          쿠폰형
        </span>
      );
    case 'delivery':
      return (
        <span className="inline-flex rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700">
          배송형
        </span>
      );
    case 'mixed':
      return (
        <span className="inline-flex rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">
          혼합
        </span>
      );
  }
};

export const DeliveryModeBadge: FC<{ mode?: GiftOrderDeliveryMode }> = ({ mode }) => {
  if (!mode) return null;
  if (mode === GiftOrderDeliveryMode.Bulk) {
    return (
      <span className="inline-flex rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-600">
        일괄배송
      </span>
    );
  }
  return (
    <span className="inline-flex rounded-full bg-teal-100 px-1.5 py-0.5 text-[10px] font-medium text-teal-700">
      개별배송
    </span>
  );
};
